import { TokenResponseBody } from '../core/theme'
import { apiEndpointAction } from './variables'

export const getToken = async (): Promise<string> => {
  try {
    const HTTP = apiEndpointAction('token', 'user/token')
    const responseRAW = await fetch(HTTP, {
      mode: 'cors',
      credentials: 'include'
    })
    const contentType = responseRAW.headers.get('content-type') ?? ''
    if (!responseRAW.ok || !contentType.includes('application/json')) {
      throw new Error('Unable to load CSRF token')
    }

    const response: TokenResponseBody = await responseRAW.json()
    if (!response.token) {
      throw new Error('CSRF token is missing')
    }
    return response.token
  } catch (error) {
    if (error instanceof Error && error.message === 'CSRF token is missing') {
      throw error
    }
    throw new Error('Unable to load CSRF token')
  }
}
